import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Intro from "../../elements/blocks/intro";
import AudiencesMetrics from "../../elements/campaigns/audience/audiences-metrics";
import TicketsMetrics from "../../elements/tickets/tickets-metrics";
import TicketsTable from "../../elements/tickets/tickets-table";
import InformationFieldsMetrics from "../../elements/tickets/information-fields-metrics";
import AudienceCards from "../../elements/campaigns/audience/audience-cards";
import Controls from "../../elements/blocks/controls";
import GroupCard from "../../elements/groups/group-card";
import Nope from "../../elements/blocks/nope";
import { useApiTenant } from "../../../api/api-tenant";
import { useRoles } from "../../../services/roles";
import { useAuth } from "../../../services/auth";
import { flatGroups } from "../../../helpers/groups";
import analytics from "../../../helpers/analytics";
export default function CampaignGroups() {
    const { t } = useTranslation();
    const { id } = useParams();
    const api = useApiTenant();
    const auth = useAuth();
    const roles = useRoles();
    const [tab, setTab] = useState("groups");
    const [campaign, setCampaign] = useState(null);
    const [statusCount, setStatusCount] = useState(null);
    const [priorityCount, setPriorityCount] = useState(null);
    const [groups, setGroups] = useState([]);
    const [search, setSearch] = useState("");
    const [filteredGroups, setFilteredGroups] = useState(null);
    const [campaignVisible, setCampaignVisible] = useState(false);
    const [isCampaignLoading, setIsCampaignLoading] = useState(true);
    const [resetStatusAndPriorityCount, setResetStatusAndPriorityCount] = useState(false);
    const [range, setRange] = useState("none");
    const [startDate, setStartDate] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endDate, setEndDate] = useState("");
    const [endTime, setEndTime] = useState("");
    const [isChosenGlobalCustomRange, setIsChosenGlobalCustomRange] = useState(false);
    const getCampaign = () => {
        api.GET_campaign(id)
            .then(response => {
            var _a, _b;
            getStatusAndPriorityCount();
            if (roles.isAgent) {
                let related = [];
                let flatTenantGroups = [];
                if (roles.groupsTenant) {
                    flatTenantGroups = flatGroups(roles.groupsTenant, 0, []);
                }
                if (response.data.campaign.groups.length > 0) {
                    response.data.campaign.groups.map(group => {
                        flatTenantGroups.map(i => {
                            if (i.id === group.id) {
                                related.push(group);
                            }
                        });
                    });
                }
                if ((response.data.campaign.groups &&
                    response.data.campaign.active &&
                    ((_a = response.data.campaign.groups) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                    related.length > 0) ||
                    (response.data.campaign.active &&
                        ((_b = response.data.campaign.groups) === null || _b === void 0 ? void 0 : _b.length) === 0)) {
                    setCampaignVisible(true);
                }
            }
            else {
                setCampaignVisible(true);
            }
            let groups = flatGroups(response.data.campaign.groups, 0, []);
            groups = groups.sort((a, b) => a.name.localeCompare(b.name));
            setGroups(groups);
            setCampaign(response.data.campaign);
            setIsCampaignLoading(false);
        })
            .catch(error => {
            if (!api.isCancel(error)) {
                console.error(error);
                setIsCampaignLoading(false);
            }
        });
    };
    const getStatusAndPriorityCount = () => {
        api.GET_campaign(id, 1)
            .then(response => {
            setStatusCount(response.data.campaign.ticket_statuses);
            setPriorityCount(response.data.campaign.ticket_priorities);
        })
            .catch(error => {
            if (!api.isCancel(error))
                console.error(error);
        });
    };
    useEffect(() => {
        getCampaign();
        return () => api.cancel();
    }, []);
    useEffect(() => {
        if (!resetStatusAndPriorityCount)
            return;
        setStatusCount(null);
        setPriorityCount(null);
        getStatusAndPriorityCount();
        setResetStatusAndPriorityCount(false);
    }, [resetStatusAndPriorityCount]);
    useEffect(() => {
        if (tab === "audiences" || tab === "reports") {
            analytics.sendModalView("/tab/" + tab, auth.user);
        }
        if (tab === "groups" || tab === "audiences")
            setSearch("");
    }, [tab]);
    useEffect(() => {
        setStartDate("");
        setStartTime("");
        setEndDate("");
        setEndTime("");
    }, [range]);
    useEffect(() => {
        let newGroups = [];
        if (search && search !== "") {
            groups.map(group => {
                if (group.name.toLocaleLowerCase().includes(search.toLocaleLowerCase()))
                    newGroups.push(group);
            });
            setFilteredGroups(newGroups);
        }
        else {
            setFilteredGroups(null);
        }
    }, [search]);
    return (_jsxs(Fragment, { children: [_jsx(Intro, { name: t("queues.queues"), breadcrumbs: [
                    {
                        name: t("campaigns.campaigns"),
                        link: "/campaigns",
                    },
                    {
                        name: campaign && campaignVisible ? campaign.name : t("campaigns.campaign"),
                        link: "/campaigns/" + id,
                    },
                    {
                        name: t("queues.queues"),
                        link: "/campaigns/" + id + "/groups",
                    },
                ], loading: isCampaignLoading }), isCampaignLoading ? (_jsx(Fragment, {})) : campaign ? (campaignVisible ? (_jsxs(Fragment, { children: [roles.isAdmin || roles.isManager ? (campaign.type === "outbound" ? (_jsx(Controls, { tabs: [
                            {
                                label: t("tickets.tickets"),
                                value: "tickets",
                            },
                            {
                                label: t("queues.queues"),
                                value: "groups",
                            },
                            {
                                label: t("campaigns.audiences.audiences"),
                                value: "audiences",
                            },
                            {
                                label: t("campaigns.reports"),
                                value: "reports",
                            },
                        ], tab: tab, setTab: setTab, enableSearch: tab === "audiences" || tab === "groups", search: search, setSearch: setSearch, enableDateChanging: tab === "reports", range: range, setRange: setRange, startDate: startDate, setStartDate: setStartDate, startTime: startTime, setStartTime: setStartTime, endDate: endDate, setEndDate: setEndDate, endTime: endTime, setEndTime: setEndTime, setIsChosenGlobalCustomRange: setIsChosenGlobalCustomRange })) : (_jsx(Controls, { tabs: [
                            {
                                label: t("tickets.tickets"),
                                value: "tickets",
                            },
                            {
                                label: t("queues.queues"),
                                value: "groups",
                            },
                            {
                                label: t("campaigns.reports"),
                                value: "reports",
                            },
                        ], tab: tab, setTab: setTab, enableSearch: tab === "groups", search: search, setSearch: setSearch, enableDateChanging: tab === "reports", range: range, setRange: setRange, startDate: startDate, setStartDate: setStartDate, startTime: startTime, setStartTime: setStartTime, endDate: endDate, setEndDate: setEndDate, endTime: endTime, setEndTime: setEndTime, setIsChosenGlobalCustomRange: setIsChosenGlobalCustomRange }))) : (_jsx(Controls, { tabs: [
                            {
                                label: t("tickets.tickets"),
                                value: "tickets",
                            },
                            {
                                label: t("queues.queues"),
                                value: "groups",
                            },
                        ], tab: tab, setTab: setTab, enableSearch: tab === "groups", search: search, setSearch: setSearch })), tab === "tickets" ? (_jsx(TicketsTable, { type: "campaign", campaign: campaign, setResetStatusAndPriorityCount: setResetStatusAndPriorityCount, user: campaign && campaign.type === "contract"
                            ? roles.userTenant
                                ? roles.userTenant
                                : undefined
                            : undefined, statusCount: statusCount, priorityCount: priorityCount })) : tab === "audiences" ? (_jsx(AudienceCards, { campaign: campaign, search: search ? search : "" })) : tab === "groups" ? (campaignVisible ? (_jsx(Fragment, { children: filteredGroups !== null ? (_jsx(Grid, Object.assign({ container: true, spacing: 4, direction: "row", alignItems: "stretch" }, { children: filteredGroups.length > 0 ? (filteredGroups.map(group => (_jsx(GroupCard, { group: group, groups: groups }, group.id)))) : (_jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(Nope, { caption: t("queues.no-queues") }) }))) }))) : groups && groups.length > 0 ? (_jsx(Grid, Object.assign({ container: true, spacing: 4, direction: "row", alignItems: "stretch" }, { children: groups.map(group => (_jsx(GroupCard, { group: group, groups: groups, campaign: campaign }, group.id))) }))) : (_jsx(Nope, { caption: t("queues.no-queues") })) })) : (_jsx(Nope, { title: t("errors.unauthorized"), caption: t("errors.no-permission") }))) : (_jsxs(Fragment, { children: [_jsx(TicketsMetrics, { type: "campaign", campaign: campaign, globalRange: range, setGlobalRange: setRange, globalStartDate: startDate, globalStartTime: startTime, globalEndDate: endDate, globalEndTime: endTime, isChosenGlobalCustomRange: isChosenGlobalCustomRange }), campaign.type === "outbound" && (_jsxs(Fragment, { children: [_jsx(Box, Object.assign({ sx: { paddingTop: 1, paddingBottom: 4 } }, { children: _jsx(Divider, {}) })), _jsx(AudiencesMetrics, { campaign_id: campaign.id, globalRange: range, setGlobalRange: setRange, globalStartDate: startDate, globalStartTime: startTime, globalEndDate: endDate, globalEndTime: endTime, isChosenGlobalCustomRange: isChosenGlobalCustomRange })] })), _jsx(InformationFieldsMetrics, { type: "campaign", campaign: campaign, information_type: "choice", globalRange: range, setGlobalRange: setRange, globalStartDate: startDate, globalStartTime: startTime, globalEndDate: endDate, globalEndTime: endTime, isChosenGlobalCustomRange: isChosenGlobalCustomRange }), _jsx(InformationFieldsMetrics, { type: "campaign", campaign: campaign, information_type: "field", globalRange: range, setGlobalRange: setRange, globalStartDate: startDate, globalStartTime: startTime, globalEndDate: endDate, globalEndTime: endTime, isChosenGlobalCustomRange: isChosenGlobalCustomRange })] }))] })) : (_jsx(Nope, { title: t("errors.unauthorized"), caption: t("errors.no-permission") }))) : (_jsx(Nope, { title: t("errors.404"), caption: t("campaigns.errors.not-found") }))] }));
}
